// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-c1cd11d9] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.item-list__entry[data-v-c1cd11d9] {
  display: flex;
  align-items: flex-start;
  position: relative;
  padding: 8px;
}
.item-list__entry[data-v-c1cd11d9]:hover, .item-list__entry[data-v-c1cd11d9]:focus {
  background-color: var(--color-background-hover);
  border-radius: var(--border-radius-large);
}
.item-list__entry .item-avatar[data-v-c1cd11d9] {
  position: relative;
  margin-top: auto;
  margin-bottom: auto;
}
.item-list__entry .item__details[data-v-c1cd11d9] {
  padding-left: 8px;
  max-height: 44px;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 44px;
}
.item-list__entry .item__details h3[data-v-c1cd11d9],
.item-list__entry .item__details .message[data-v-c1cd11d9] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-list__entry .item__details .message span[data-v-c1cd11d9] {
  width: 10px;
  display: inline-block;
  margin-bottom: -3px;
}
.item-list__entry .item__details h3[data-v-c1cd11d9] {
  font-size: 100%;
  margin: 0;
}
.item-list__entry .item__details .message[data-v-c1cd11d9] {
  width: 100%;
  color: var(--color-text-maxcontrast);
}
.item-list__entry .item-icon[data-v-c1cd11d9] {
  position: relative;
  width: 14px;
  height: 14px;
  margin: 27px -3px 0px -7px;
}
.item-list__entry button.primary[data-v-c1cd11d9] {
  padding: 21px;
  margin: 0;
}

/*
.content-popover {
	height: 0px;
	width: 0px;
	margin-left: auto;
	margin-right: auto;
}
.popover-container {
	width: 100%;
	height: 0px;
}
*/`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDashboardWidgetItem-JCtQhwhS.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+CAA+C;EAC/C,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;;;;;CAWC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-c1cd11d9] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.item-list__entry[data-v-c1cd11d9] {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n  padding: 8px;\n}\n.item-list__entry[data-v-c1cd11d9]:hover, .item-list__entry[data-v-c1cd11d9]:focus {\n  background-color: var(--color-background-hover);\n  border-radius: var(--border-radius-large);\n}\n.item-list__entry .item-avatar[data-v-c1cd11d9] {\n  position: relative;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.item-list__entry .item__details[data-v-c1cd11d9] {\n  padding-left: 8px;\n  max-height: 44px;\n  flex-grow: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 44px;\n}\n.item-list__entry .item__details h3[data-v-c1cd11d9],\n.item-list__entry .item__details .message[data-v-c1cd11d9] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.item-list__entry .item__details .message span[data-v-c1cd11d9] {\n  width: 10px;\n  display: inline-block;\n  margin-bottom: -3px;\n}\n.item-list__entry .item__details h3[data-v-c1cd11d9] {\n  font-size: 100%;\n  margin: 0;\n}\n.item-list__entry .item__details .message[data-v-c1cd11d9] {\n  width: 100%;\n  color: var(--color-text-maxcontrast);\n}\n.item-list__entry .item-icon[data-v-c1cd11d9] {\n  position: relative;\n  width: 14px;\n  height: 14px;\n  margin: 27px -3px 0px -7px;\n}\n.item-list__entry button.primary[data-v-c1cd11d9] {\n  padding: 21px;\n  margin: 0;\n}\n\n/*\n.content-popover {\n\theight: 0px;\n\twidth: 0px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n.popover-container {\n\twidth: 100%;\n\theight: 0px;\n}\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
